import axios from 'axios'
const api = "configurar"

const cedisImagen = {
    getCedis: () => axios.get(`${api}/get-cedis-imagen`),
    setImagen: (cedi,foto) => axios.put(`${api}/${cedi}/set-cedis-imagen`,foto)
}
export default cedisImagen